<template>
  <div>
    <b-card
      class="traffic-card"
      no-body
    >
      <div class="card-header">
        <span class="title">ข้อมูลจราจรรายชั่วโมง</span>
      </div>
      <div class="card-body">
        <div
          v-if="loading"
          class="loading-state"
        >
          <b-spinner
            variant="success"
            label="Loading..."
          />
        </div>
        <div
          v-else-if="error"
          class="error-state"
        >
          {{ error }}
          <b-button
            size="sm"
            variant="outline-light"
            @click="getBarChart"
          >
            ลองใหม่
          </b-button>
        </div>
        <app-echart-bar
          v-else
          :option-data="optionBar"
          class="chart"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BSpinner,
  BButton,
} from 'bootstrap-vue'
import axios from '@axios'
import echarts from 'echarts'
import AppEchartBar from './AppEchartBarCounting.vue'

export default {
  name: 'TrafficHourlyChart',

  components: {
    AppEchartBar,
    BCard,
    BSpinner,
    BButton,
  },

  data() {
    return {
      loading: false,
      error: null,
      interval: null,
      optionBar: {
        xAxisData: [],
        series: [{
          name: 'ทั้งหมด',
          type: 'bar',
          stack: 'Total',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: '#99FBCA',
              },
              {
                offset: 1,
                color: '#00B058',
              },
            ]),
            barBorderRadius: [4, 4, 0, 0],
          },
          data: [],
          barMaxWidth: '40%',
          barMinWidth: '10px',
        }],
      },
    }
  },

  mounted() {
    this.initChart()
  },

  beforeDestroy() {
    this.clearInterval()
  },

  methods: {
    initChart() {
      this.getBarChart()
      this.startInterval()
    },

    startInterval() {
      this.clearInterval()
      this.interval = setInterval(() => {
        this.getBarChart()
      }, 300000) // 5 minutes
    },

    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },

    async getBarChart() {
      // ถ้ากำลังโหลดอยู่ ไม่ต้องเรียก API ซ้ำ
      if (this.loading) return

      this.loading = true
      this.error = null

      try {
        // ขอข้อมูลจาก API ด้วย axios
        const response = await axios.post('/node-red/get-Vehicles-Hourly-WIM', {
          wid: this.$route.query.wid,
        }, {
          baseURL: 'https://wts.drr.go.th',
          headers: {
            'Content-Type': 'application/json',
          },
          timeout: 10000, // 10 seconds timeout
        })

        // อัพเดทข้อมูลกราฟ
        const { data } = response
        this.optionBar.xAxisData = data.map(value => value.Period_Name)
        this.optionBar.series[0].data = data.map(value => value.total_vehicles)
      } catch (error) {
        console.error('Error fetching data:', error)
        this.error = 'ไม่สามารถโหลดข้อมูลได้'
        // ถ้าเกิด error ให้ลองใหม่ในอีก 30 วินาที
        setTimeout(() => {
          this.getBarChart()
        }, 30000)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.traffic-card {
  width: 100%;
  height: 320px;
  border-radius: 10px;
}

.card-header {
  padding: 1rem;
}

.title {
  font-size: 20px;
  color: #fff;
}

.chart {
  width: auto;
  height: 300px;
  margin-top: 10px;
}

.loading-state,
.error-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 260px;
  color: #fff;
  gap: 1rem;
}
</style>
